import React, { Component } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './TelemetryService';
import { withRouter } from 'react-router-dom';
import ErrorHandler from '../Components/ErrorHandler';
import CanPerformOnlineHandler from '../Components/CanPerformOnlineHandler';

const AppInsightsConnectionString = process.env.REACT_APP_INSIGHTS_CONNECTION_STRING;

class TelemetryProvider extends Component {
   state = {
      initialized: false,
      appInsight: null,
   };

   componentDidMount() {
      const { history } = this.props;
      const { initialized } = this.state;

      if (!initialized && AppInsightsConnectionString && history) {
         try {
            const appInsight = ai.initialize(AppInsightsConnectionString, history);
            this.setState({ initialized: true, appInsight });
         } catch (error) {
            console.error('[TelemetryProvider] Failed to initialize telemetry:', error);
         }
      }
   }

   render() {
      const { children } = this.props;
      return (
         <ErrorHandler appInsight={this.state.appInsight}>
            <CanPerformOnlineHandler>{children}</CanPerformOnlineHandler>
         </ErrorHandler>
      );
   }
}

export default withRouter(
   withAITracking(ai.reactPlugin, TelemetryProvider, undefined, 'ai-container')
);
